import dayjs from "dayjs";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportGedInternoUseCase } from "../../../presentation/useCases/read/get_report_ged_interno_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportGedInternoUseCase
 */

export class GetReportGedInternoUseCase implements IGetReportGedInternoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportGedInterno(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportGedInterno(requiredMimeType);

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `ged_interno_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }

    return response;
  }
}
